module.exports = __webpack_public_path__ + "img/adminonly_icon.fd2e06b8.svg";